import styled from 'styled-components';
export const OptionsContainer = styled.ul `
  position: absolute;
  margin: 0;
  left: 0;
  width: 100%;
  background-color: #fff;
  z-index: 2;
  display: block;
  box-sizing: border-box;
  ${({ flyoutMaxItemsCount, isMultipleSelect, withFooter }) => isMultipleSelect && withFooter
    ? 'auto'
    : isMultipleSelect
        ? `max-height: ${flyoutMaxItemsCount * 2.5 + 1.5}rem`
        : `max-height: ${flyoutMaxItemsCount * 2.5 + 1}rem`};
  overflow-y: ${({ isMultipleSelect, withFooter }) => isMultipleSelect && withFooter ? 'hidden' : 'auto'};
  ${({ theme }) => `box-shadow: 0 2px 6px rgba(${theme.colors.transparentBlack}, 0.26);`}
  padding: ${({ isMultipleSelect }) => (isMultipleSelect ? '0' : '0.5rem 0')};
  transition: opacity 0.3s ${({ opened }) => (opened ? 'ease-in' : 'ease-out')},
    visibility 0s ${({ opened }) => (opened ? 'ease-in' : 'ease-out')};
  ${({ opened }) => `visibility: ${opened ? 'visible' : 'hidden'};`}
  ${({ opened }) => `opacity: ${opened ? '1' : '0'};`}
  ${({ openDirection = 'bottom' }) => (openDirection === 'top' ? `bottom: 100%;` : `top: 100%;`)}

  > div {
    flex: 1;
    ${({ isMultipleSelect, withFooter }) => isMultipleSelect && withFooter
    ? 'max-height: 10rem'
    : isMultipleSelect
        ? 'max-height: 13rem'
        : ''};
  }

  li {
    padding-right: 0;

    div {
      flex: 1;
    }
  }
`;
